import React from 'react';
import { cx } from './cx';
import type { AdminTone } from './tokens';

export interface AdminStatusPillProps {
  tone?: AdminTone;
  /** icon lucide 12px trước chữ (tuỳ chọn) */
  icon?: React.ReactNode;
  className?: string;
  title?: string;
  children: React.ReactNode;
}

// Nhãn trạng thái: viên 24px, chữ 12px 600, nền nhạt + chữ đậm cùng họ màu.
export const AdminStatusPill = ({ tone = 'neutral', icon, className, title, children }: AdminStatusPillProps) => (
  <span className={cx('adm-status', `adm-status--${tone}`, className)} title={title}>
    {icon}
    {children}
  </span>
);

export default AdminStatusPill;
